import './live-countdown.css';

import React from 'react';

type Params = {
  description?: string;
  secondsUntilLive: number;
};

const LiveCountdownContainer: React.FC<Params> = ({ secondsUntilLive }) => {
  const format = (number: number) => {
    return number.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  };

  const hours = format(Math.floor(secondsUntilLive / 3600));
  const minutes = format(Math.floor((secondsUntilLive % 3600) / 60));
  const seconds = format(secondsUntilLive % 60);

  return (
    <div className="live-countdown">
      <h4>{'Sua aula começa em'}</h4>
      <div className="countdown">
        <div className="countdown-box">
          <p>{hours}</p>
        </div>
        <p>{':'}</p>
        <div className="countdown-box">
          <p>{minutes}</p>
        </div>
        <p>{':'}</p>
        <div className="countdown-box">
          <p>{seconds}</p>
        </div>
      </div>
    </div>
  );
};

export default LiveCountdownContainer;
